/**
 * 🛡️ Utilitário para validação segura de objetos de pedido
 * 
 * SEMPRE use estas funções quando acessar propriedades de pedido
 * para evitar erros de "Cannot read property of undefined"
 */

export function isPedidoValido(pedido: any): boolean {
  return !!(pedido?.id);
}

export function getPedidoIdSeguro(pedido: any): string | null {
  return pedido?.id || null;
}

export function getPedidoMaeIdSeguro(pedido: any): string | null {
  return pedido?.pedido_mae_id || null;
}

export function formatPedidoIdParaLog(id: string | null | undefined): string {
  if (!id) return 'N/A';
  try {
    return id.substring(0, 8);
  } catch {
    return String(id);
  }
}

export function logPedidoSeguro(label: string, pedido: any) {
  if (!pedido) {
    console.log(`${label}: pedido é null/undefined`);
    return;
  }
  
  console.log(label, {
    pedidoId: formatPedidoIdParaLog(pedido.id),
    numeroPedido: pedido.numero_pedido || 'N/A',
    pedidoMaeId: formatPedidoIdParaLog(pedido.pedido_mae_id),
    ehFilho: !!pedido.pedido_mae_id
  });
}
